var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container__nims"},[_c('p',{staticClass:"title"},[_vm._v("신청이 성공적으로 접수 되었습니다.")]),_c('p',{staticClass:"title-sub"},[_vm._v("결제 및 환불과 관련하여 빠른 시일 내에 연락을 드리겠습니다.")]),(_vm.isRender)?_c('NimsModifyStep02Template',{attrs:{"changeOrderInfo":_vm.changeOrderInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }